export default "__VITE_ASSET__DxToshd$__"